import React from 'react'
import { graphql } from 'gatsby'

import { processContext } from '../contentful'
import { ContactElement } from '../enums'
import Home from '../page-components/Home'

interface Props {
  data: PageQueryData
}

const HomePage: React.FC<Props> = ({ data }) => (
  <Home
    pageContext={{
      ...processContext(data),
      contactLinkOptions: { element: ContactElement.ContactSection },
    }}
  />
)

export const query = graphql`
  query {
    page: allContentfulPage(filter: {slug: {eq: "home"}}) {
      edges {
        node {
          ... PageFragment
        }
      }
    }
  }`

export default HomePage
